var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Basic = require("../../../../elements/Basic");

var _Touchable = _interopRequireDefault(require("../../Basic/Touchable"));

var _TeamCard = _interopRequireDefault(require("./TeamCard"));

var _GoalCard = _interopRequireDefault(require("./GoalCard"));

var _ColorUtility = require("./ColorUtility");

var _PropsHelper = require("../../../../utilities/PropsHelper");

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Betting/Voting/CardContainer.js";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2.default)(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2.default)(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return (0, _possibleConstructorReturn2.default)(this, result);
  };
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

var CardContainer = function (_React$Component) {
  (0, _inherits2.default)(CardContainer, _React$Component);

  var _super = _createSuper(CardContainer);

  function CardContainer() {
    var _this;

    (0, _classCallCheck2.default)(this, CardContainer);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _this.getCuttedOption = function () {
      if (_this.props.option.percent < 0) {
        return _objectSpread(_objectSpread({}, _this.props.option), {}, {
          percent: 0
        });
      }

      if (_this.props.option.percent > 100) {
        return _objectSpread(_objectSpread({}, _this.props.option), {}, {
          percent: 100
        });
      }

      return _this.props.option;
    };

    _this.renderCard = function (type, index, votedForOption, option, useFontelloIcons, iconSize, minWidth) {
      switch (type) {
        case 'RESULT_1x2':
        case 'NEXT_GOAL':
          return _react.default.createElement(_TeamCard.default, {
            isCenterCard: index === 1,
            votedForTeam: votedForOption,
            team: option,
            useFontelloIcons: useFontelloIcons,
            iconSize: iconSize,
            minWidth: minWidth,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 42,
              columnNumber: 21
            }
          });

        case 'GOALS_OVER_UNDER':
          return _react.default.createElement(_GoalCard.default, {
            index: index,
            goal: option,
            __source: {
              fileName: _jsxFileName,
              lineNumber: 52,
              columnNumber: 24
            }
          });

        default:
          return null;
      }
    };

    return _this;
  }

  (0, _createClass2.default)(CardContainer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          type = _this$props.type,
          index = _this$props.index,
          hasBeenVoted = _this$props.hasBeenVoted,
          isVotedFor = _this$props.isVotedFor,
          onPress = _this$props.onPress,
          _this$props$cardShado = _this$props.cardShadow,
          cardShadow = _this$props$cardShado === void 0 ? {} : _this$props$cardShado,
          _this$props$useFontel = _this$props.useFontelloIcons,
          useFontelloIcons = _this$props$useFontel === void 0 ? true : _this$props$useFontel,
          highlightColor = _this$props.highlightColor,
          minWidth = _this$props.minWidth,
          iconSize = _this$props.iconSize;
      var cuttedOption = this.getCuttedOption();
      var proportions = [{
        percentage: 100 - cuttedOption.percent + "%",
        bg: 'transparent'
      }, {
        percentage: cuttedOption.percent + "%",
        bg: isVotedFor && highlightColor || 'border.main'
      }];
      return _react.default.createElement(_Basic.Column, {
        flexing: true,
        center: true,
        overflow: "hidden",
        mb: hasBeenVoted ? 2 : 0,
        px: ['7px', '10px', '10px'],
        __source: {
          fileName: _jsxFileName,
          lineNumber: 83,
          columnNumber: 13
        }
      }, _react.default.createElement(_Touchable.default, {
        onPress: !hasBeenVoted ? (0, _PropsHelper.getFunctionAsCallbackOrUndefined)(onPress) : undefined,
        width: "100%",
        minWidth: minWidth,
        position: "relative",
        mb: !hasBeenVoted || cardShadow ? 2 : 0,
        borderX: 1,
        borderY: 1,
        opacity: hasBeenVoted && !isVotedFor ? 0.5 : 1,
        borderColor: isVotedFor ? highlightColor || 'highlight.secondary' : 'border.main',
        boxShadow: (0, _PropsHelper.getValueConditionally)(cardShadow && !hasBeenVoted, '2px 2px #ddd'),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 90,
          columnNumber: 17
        }
      }, _react.default.createElement(_Basic.Column, (0, _extends2.default)({
        isFlex: true,
        overflow: "hidden",
        bg: "background.main"
      }, cardShadow, {
        __source: {
          fileName: _jsxFileName,
          lineNumber: 104,
          columnNumber: 21
        }
      }), hasBeenVoted && _react.default.createElement(_ColorUtility.Gradient, {
        proportions: proportions,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 105,
          columnNumber: 42
        }
      }), this.renderCard(type, index, isVotedFor, cuttedOption, useFontelloIcons, iconSize, minWidth))), hasBeenVoted && _react.default.createElement(_Basic.Text, {
        size: "large",
        color: "font.main",
        mb: 2,
        bold: isVotedFor,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 118,
          columnNumber: 21
        }
      }, cuttedOption.percent, "%"));
    }
  }]);
  return CardContainer;
}(_react.default.Component);

CardContainer.propTypes = {
  type: _propTypes.default.string.isRequired,
  option: _propTypes.default.object.isRequired,
  index: _propTypes.default.number,
  isMaximum: _propTypes.default.bool,
  hasBeenVoted: _propTypes.default.bool.isRequired,
  isVotedFor: _propTypes.default.bool.isRequired,
  onPress: _propTypes.default.func,
  cardShadow: _propTypes.default.object,
  useFontelloIcons: _propTypes.default.bool,
  highlightColor: _propTypes.default.string
};
var _default = CardContainer;
exports.default = _default;